export default __webpack_public_path__ + "static/media/products.b2a24632.svg";